export const NOTIFICATION_TABS = ['all', 'mentions'] as const;
